<ng-container *transloco="let t; read: 'password'">
	<form-wrapper [header]="t('titleChange')" *ngIf="!processingRequest; else loading">
		<form *ngIf="!passwordChanged; else done" [formGroup]="passwordChangeForm" (ngSubmit)="changePassword()">
			<div class="app-text__label-l">{{t('labelCurrentPassword')}}</div>
			<input type="password" formControlName="currentPassword" appAutofocus>
			<val-error controlNameToValidate="currentPassword">{{t('validationCurrentPassword')}}</val-error>
			<div class="app-text__label-l mti-5">{{t('labelNewPassword')}}</div>
			<input type="password" formControlName="newPassword">
			<val-error controlNameToValidate="newPassword">{{t('validationNewPassword')}}</val-error>
			<div class="mti-14">
				<app-button class="cwi-57" [disabled]="!passwordChangeForm.valid" (click)="changePassword()">
					{{'buttons.changePassword' | transloco}}
				</app-button>
				<app-button class="cwi-57 mti-5" appearance="outline" (click)="complete()">
					{{'buttons.cancel' | transloco}}
				</app-button>
			</div>
		</form>
		<ng-template #done>
			<div class="app-text__body-m mbi-5">
				{{t('passwordChanged_2')}}
			</div>
			<app-button appearance="outline" (click)="complete()">
				{{'buttons.ok' | transloco}}
			</app-button>
		</ng-template>
	</form-wrapper>
</ng-container>

<ng-template #loading>
	<div class="flex flex-jc-center mti-19">
		<app-loader [loading]="true">
		</app-loader>
	</div>
</ng-template>